import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ 
  size = 'md', 
  variant = 'primary', 
  text = 'Đang tải...', 
  centered = true,
  className = '',
  showText = true 
}) => {
  const spinnerSize = size === 'sm' ? 'sm' : size === 'lg' ? 'lg' : undefined;
  
  const content = (
    <div className={`d-flex flex-column align-items-center ${className}`}>
      <Spinner 
        animation="border" 
        variant={variant} 
        size={spinnerSize}
        className="mb-2"
      />
      {showText && (
        <small className="text-muted">
          {text}
        </small>
      )}
    </div>
  );

  if (centered) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;
